import { render } from "./LabsquireTestTubesInfo.vue?vue&type=template&id=3ca53ea3&scoped=true"
import script from "./LabsquireTestTubesInfo.vue?vue&type=script&lang=js"
export * from "./LabsquireTestTubesInfo.vue?vue&type=script&lang=js"

import "./LabsquireTestTubesInfo.vue?vue&type=style&index=0&id=3ca53ea3&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca53ea3"],['__file',"src/components/orders/LabsquireTestTubesInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ca53ea3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ca53ea3', __exports__)) {
    console.log('reload')
    api.reload('3ca53ea3', __exports__)
  }
  
  module.hot.accept("./LabsquireTestTubesInfo.vue?vue&type=template&id=3ca53ea3&scoped=true", () => {
    console.log('re-render')
    api.rerender('3ca53ea3', render)
  })

}


export default __exports__